interface ModalFormHeaderProps {
    currentAction: string
}

const ModalFormHeader = ({currentAction}: ModalFormHeaderProps) => {
    return (
        <h3 className="text-xl font-medium text-gray-900 dark:text-white">
            {currentAction === 'add' && <>Add an item</>}
            {currentAction === 'edit' && <>Update an item</>}
        </h3>
    )    
}

export default ModalFormHeader;